import { Inline, useCollapse } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useProductsImport } from 'hooks'
import { LIMITS } from 'shared'
import { Item } from 'typings'
import { ProductsSelector } from 'ui'
import { CollapsibleRule } from '../CollapsibleRule'
import { SelectorComponentProps } from '../constants'
import { OperatorSelector } from '../OperatorSelector'

export function ProductsScopeSelector(props: SelectorComponentProps) {
  const { name, form, open } = props

  const items: Item[] = useWatch({ form, name: `${name}.items` })

  const collapsibleState = useCollapse({ visible: open })

  const { importProducts, loading } = useProductsImport()

  return (
    <CollapsibleRule state={collapsibleState}>
      <CollapsibleRule.Header
        state={collapsibleState}
        onRemove={() => form.setValue(name, undefined)}
      >
        <CollapsibleRule.Title state={collapsibleState} count={items.length}>
          <ProductsSelector.Header />
        </CollapsibleRule.Title>
      </CollapsibleRule.Header>
      <CollapsibleRule.Content
        state={collapsibleState}
        focusId={`${name}.items`}
      >
        <ProductsSelector>
          <CollapsibleRule.Actions>
            <OperatorSelector name={`${name}.operator`} form={form} />
            <Inline>
              <ProductsSelector.Download values={items} />
              <ProductsSelector.Upload
                name={`${name}.items`}
                form={form}
                maxEntries={LIMITS.MAX_PRODUCTS}
                importer={importProducts}
              />
            </Inline>
          </CollapsibleRule.Actions>
          <ProductsSelector.Selector
            name={`${name}.items`}
            state={form}
            loading={loading}
          />
        </ProductsSelector>
      </CollapsibleRule.Content>
    </CollapsibleRule>
  )
}
